import { Box } from "arkh";
import React, { useMemo } from "react";
import { useIntlTokens } from "../../../../../../components/mobile/useIntlTokens";
import { getWidgetAddWidgetSizeWithinBounds } from "../../utils/useWidgetAddWidgetSizeState";
import { WACategoryScreenProps } from "../../WANavigation";
import { WACategoryWidgetContainer } from "../../WACategoryWidgetContainer";
import { overviewWidgetSizes } from "../../utils/widgetSizes/overviewWidgetSizes";

import { WidgetFileMockPreview } from "./WidgetFileMockPreview";
import { WidgetSizeT } from "../../../localTypes/WidgetSizeT";
import { useWACategoryLayout } from "../../utils/useWACategoryLayout";

type Props = WACategoryScreenProps<"WACategoryFile">;

export function WACategoryFileComponent(props: {
  maxSize: WidgetSizeT;
  unitSize: number;
  onAdd(): void;
}) {
  const intl_tokens = useIntlTokens();

  const [teamScheduleSize, hasSizeWithinBounds] = useMemo(
    () =>
      getWidgetAddWidgetSizeWithinBounds({
        widgetSizes: overviewWidgetSizes,
        maxSize: props.maxSize,
      }),
    [props.maxSize]
  );

  const paddingHorizontal = useWACategoryLayout().paddingHorizontal;

  return (
    <Box
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal,
      }}
      spaceVertical="xlarge"
    >
      <WACategoryWidgetContainer
        hasSizeWithinBounds={hasSizeWithinBounds}
        size={
          teamScheduleSize.h > 3
            ? {
                h: 3,
                w: 2,
              }
            : teamScheduleSize
        }
        title={intl_tokens.Files}
        unitSize={props.unitSize}
        onAdd={props.onAdd}
        addTitle={intl_tokens.Select}
        description=""
      >
        <WidgetFileMockPreview />
      </WACategoryWidgetContainer>
    </Box>
  );
}

export function WACategoryFile(props: Props) {
  return (
    <WACategoryFileComponent
      maxSize={props.route.params.maxSize}
      unitSize={props.route.params.unitSize}
      onAdd={() => {
        props.navigation.navigateDeprecated("WidgetAddFile", {
          defaultTeams: props.route.params.defaultTeams,
          maxSize: props.route.params.maxSize,
          unitSize: props.route.params.unitSize,
          storecastId: props.route.params.storecastId,
          position: props.route.params.position,
        });
      }}
    />
  );
}
